import { z } from 'zod';

import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { UserPaymentMethods, userPaymentMethodsResponseSchema } from '../models/user-payment-method';

export async function getUserPaymentMethods(): Promise<UserPaymentMethods> {
  const userId = auth.getCurrentUserId();
  const jwt = auth.getJWT();

  if (!userId || !jwt) {
    return [];
  }

  const data = await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_BRAAVOS_URL}/users/${userId}/payment_methods`,
    method: 'GET',
    zodSchema: z.any(),
    authorization: `Bearer ${jwt}`,
  });

  const userPaymentMethods = userPaymentMethodsResponseSchema.parse(data);

  return userPaymentMethods.filter((userPaymentMethod) => Boolean(userPaymentMethod.savedCreditCard));
}
